// @ts-nocheck
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import {
  CertificatesPage,
  ErrorPage,
  MainPage,
  UsefulPage,
  DeliveryPage,
  ContactsPage,
  LK,
  LKReg,
  FastRegistration,
  Cart,
  CartReg,
  NotFound,
  ArticlesPage,
  ArticleDetail,
} from './pages';
import Layout from './layout';
import { ROUTES_PATHS } from './const/index.js';
import './styles/fonts.css';
import './styles/index.css';
import { StoreContext } from 'context';
import NGDetail from 'pages/NGDetail';
import ProductsDetail from 'pages/Product';
import RootStore from 'store/Root';

const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: ROUTES_PATHS.MAIN,
        element: <MainPage />,
      },
      {
        path: ROUTES_PATHS.USEFUL,
        element: <UsefulPage />,
      },
      {
        path: ROUTES_PATHS.CERTIFICATES,
        element: <CertificatesPage />,
      },
      {
        path: ROUTES_PATHS.DELIVERY,
        element: <DeliveryPage />,
      },
      {
        path: ROUTES_PATHS.CONTACTS,
        element: <ContactsPage />,
      },
      {
        path: ROUTES_PATHS.PERSONAL,
        element: <LK />,
      },
      {
        path: ROUTES_PATHS.REGISTRATION,
        element: <LKReg />,
      },
      {
        path: ROUTES_PATHS.FAST_REGISTRATION,
        element: <FastRegistration />,
      },
      {
        path: ROUTES_PATHS.CART,
        element: <Cart />,
      },
      {
        path: ROUTES_PATHS.CART_REG,
        element: <CartReg />,
      },
      {
        path: ROUTES_PATHS.NG_SUBGROUP_DETAIL,
        element: <NGDetail />,
      },
      {
        path: ROUTES_PATHS.NG_DETAIL,
        element: <NGDetail />,
      },
      {
        path: ROUTES_PATHS.PRODUCT_DETAIL,
        element: <ProductsDetail />,
      },
      {
        path: ROUTES_PATHS.ARTICLE_DETAIL,
        element: <ArticleDetail />,
      },
      {
        path: ROUTES_PATHS.ARTICLES,
        element: <ArticlesPage />,
      },
      {
        path: '*',
        element: <NotFound />,
      },
    ],
  },
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StoreContext.Provider value={RootStore}>
    <RouterProvider router={router} />
  </StoreContext.Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
